<template>
  <base-spinner v-if="loading"></base-spinner>
  <div v-else class="main-container  d-flex flex-column">
    <div class="flex-shrink-0">
      <div class="row flex-column flex-lg-row">
        <div class="col-12 col-lg-6 mb-3 d-flex align-items-center flex-wrap">
          <div class="mb-1">
            <base-select
              class="mb-0 mx-1"
              :options="filter_options"
              field="selected_filter"
              :value="selected_filter"
              @change-value="setValue"
              :useI18n="true"
            >
            </base-select>
          </div>

          <div v-if="selected_filter === 'client-id'" class="mb-1 mx-1">
            <base-select
              class="mb-0"
              :options="client_options"
              field="selected_client"
              :value="selected_client"
              @change-value="setValue"
            >
            </base-select>
          </div>
          <div v-if="selected_filter === 'sales-order'" class="mb-1 mx-1">
            <base-select
              class="mb-0"
              :options="sales_orders_options"
              field="selected_sales_orders"
              :value="selected_sales_orders"
              @change-value="setValue"
            >
            </base-select>
          </div>
          <div v-if="(selected_filter === 'client-id' && selected_client) 
          || (selected_filter === 'sales-order' && selected_sales_orders)" class="mb-1 mx-1">
            <base-select
              class="mb-0"
              :options="selected_type_options"
              field="selected_type"
              :value="selected_type"
              @change-value="setValue"
            >
            </base-select>
          </div>

          <div class="mb-1 mx-1" v-if="selected_filter !== 'client-id' && selected_filter !== 'sales-order' && selected_filter">
            <base-select
              class="mb-0"
              :options="options"
              field="selected_device"
              :value="selected_device"
              @change-value="setValue"
              :disabled="!selected_filter"
            >
            </base-select>
          </div>

          <div class="mb-1 mx-1" v-if="(selected_type && (selected_filter === 'client-id' || selected_filter === 'sales-order'))
           && (selected_sales_orders || selected_client)">
            <base-select
              class="mb-0"
              :options="options_selected_device_level"
              field="selected_device_level"
              :value="selected_device_level"
              @change-value="setValue"
              :disabled="(selected_filter === 'sales-order'  ? !selected_sales_orders
              : selected_filter === 'client-id' ? !selected_client : !selected_device) || !selected_filter"
              >
            </base-select>
          </div>

          <div class="mb-1">
            <base-button
              cus_style="padding:8px 20px;width:100px"
              variant="secondary"
              @click="reset"
              :disabled="(selected_filter === 'sales-order'  ? !selected_sales_orders
              : selected_filter === 'client-id' ? !selected_client : !selected_device) || !selected_filter"
              >
              {{ $t("reset") }}
            </base-button>
          </div>
        </div>
        <div
          class="col-12 col-lg-6 mb-3 d-flex align-items-center justify-content-end flex-wrap"
        >
          <div class="d-flex align-items-center flex-wrap">
            <div class="counter">
              <span class="counter__count">
                <span class="active">
                  {{
                    $store.getters["enums/vehicle_availability"]
                      .availableVehicles
                  }}
                </span>
                /
                {{ $store.getters["enums/vehicle_availability"].totalVehicles }}
              </span>
            </div>
            <span class="counter__status mx-2">
              {{ $t("available-vehicles") }}
            </span>
          </div>

          <div class="d-flex align-items-center flex-wrap">
            <div class="counter">
              <span class="counter__count">
                <span class="active">
                  {{
                    $store.getters["enums/driver_availability"].availableDrivers
                  }}
                </span>
                /
                {{ $store.getters["enums/driver_availability"].totalDrivers }}
              </span>
            </div>
            <span class="counter__status mx-2">
              {{ $t("available-drivers") }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="zones && zones.length">
        <hr />
        <div class="label-text mb-2 mt-2">{{ $t("available-zones") }}</div>
        <div class="d-flex align-items-center mb-3">
          <div v-for="(zone, index) in zones" :key="index">
            <base-button
              cus_style="margin-right:0.5rem"
              :variant="
                selected_zone?._id === zone?._id ? 'primary' : 'secondary'
              "
              @click="selectZone(zone)"
            >
              {{ isLangRtl ? zone.arabicName : zone.name || "" }}
            </base-button>
          </div>
        </div>
      </div>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
    </div>
    <div class="flex-grow-1 mab-container">
      <div :style="'height: 100%'" id="gps-track-map-box"></div>
      <div class="box-info-map">
        <div class="box-info-map-item">
          <h5>{{$t("total-number-of-vehicles")}}:</h5>
          <p>{{ totalVehicles }}</p>
        </div>
        <div class="box-info-map-item">
          <h5>{{$t("total-number-of-drivers")}}:</h5>
          <p>{{ totalDrivers }}</p>
        </div>
        <div class="box-info-map-item">
          <h5>{{$t("total-number-of-deadhead-trips")}}:</h5>
          <p>{{ totalDeadheadTrips }}</p>
        </div>
      </div>
    </div>
    <EventTypes :event_types="event_types" />
    <send-message-modal :data="message_data" />
  </div>
</template>

<script>
import { state } from "@/socket";
import moment from "moment";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import VehicleService from "@/services/vehicle.service";
import LongTermsAgreementService from "@/services/long-term-agreement.service";
import SendMessageModal from "./sendMessageModal.vue";
import EventTypes from "../Operations/calendar/eventTypes.vue";

let map,
  markers = {};

export default {
  name: "dashboard",
  components: { SendMessageModal, EventTypes },
  data() {
    return {
      loading: false,
      error: null,
      devices: [],
      selected_vehicle: null,
      selected_filter: "all",
      options: [],
      client_options: [],
      sales_orders_options: [],
      selected_sales_orders: null,
      selected_device: null,
      selected_client: null,
      message_data: null,
      zones: [],
      selected_zone: null,
      selected_type: null,
      selected_type_options: [
        {
          value: 1,
          text: this.$t("vehicle"),
        },
        {
          value: 2,
          text: this.$t('driver'),
        },
      ],
      selected_device_level: null,
      options_selected_device_level: null,
      totalDrivers: 0,
      totalVehicles: 0,
      totalDeadheadTrips: 0,
    };
  },
  methods: {
    locationInZone(vehicleId, coordinates) {
      const location = {
        type: "Point",
        coordinates,
      };

      const selected_zone = this.zones?.find(
        (each) => vehicleId && each.vehicles.includes(vehicleId)
      );

      return vehicleId && selected_zone && selected_zone?.location
        ? turf.booleanContains(selected_zone.location, location)
        : true;
    },
    selectZone(zone) {
      if (this.selected_zone?._id === zone?._id) this.selected_zone = null;
      else this.selected_zone = zone;
      this.devices = this.devices?.map((each) => {
        each["locationInZone"] = this.locationInZone(
          each?.vehicleId,
          each.location
        );
        return each;
      });
    },
    reset() {
      this.selected_filter = "all";
      this.selected_device = null;
      this.selected_client = null;
      this.selected_device_level = null;
      this.selected_sales_orders = null;
      this.error = null;
      this.selectVehicle(null);
    },
    setValue(val, field) {
      this[field] = val;
    },
    selectVehicle(vehicle) {
      this.selected_vehicle = vehicle;
      this.setMarkers();
    },
    async getMarkerInfo(marker) {
      const query = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${marker[0]},${marker[1]}.json?access_token=${process.env.VUE_APP_MAPBOX_PK}`,
        { method: "GET" }
      );
      const json = await query.json();
      if (json?.features?.length) return json.features[0].place_name;
    },
    async setMarkers() {
      // Remove all existing markers first
      Object.keys(markers).forEach((id) => {
        markers[id].remove();
        delete markers[id];
      });
      let temp = [];
      const bounds = new mapboxgl.LngLatBounds();
      
      if (this.devices.length) {
        for (let i = 0; i < this.devices.length; i++) {
          const element = this.devices[i];
          // Skip if the client_id does not match the value
          if (!this.selected_vehicle && this.selected_client && element.client_id !== this.selected_client) {
            continue;
          }

          // Skip if the reservation does not match the value
          if (!this.selected_vehicle && this.selected_sales_orders && element.reservation !== this.selected_sales_orders) {
            continue;
          }
          if (element.location) {
            // Check if the current element is the selected vehicle
            if (this.selected_vehicle && element.id !== this.selected_vehicle.id) {
              continue; // Skip markers for other vehicles
            }

            // Skip if the reservation does not match the value
            if (!this.selected_vehicle && this.selected_sales_orders && element.reservation !== this.selected_sales_orders) {
              continue;
            }

            const { driver, vehicle, trip } = this.$route.query;
            const trip_exceed_distance =
              element.id == driver &&
              element.vehicleId == vehicle &&
              element.tripId == trip
                ? true
                : false;

            // !element.locationInZone ? "var(--color-77)"
            // : this.selected_vehicle?.id === element.id ? "var(--color-78)"
            // : element.tripStatus === "Booking-Confirmed" ? "#ffcd56"
            // : element.tripStatus === "Booking-Re-Assigned" ? "#37a2eb"
            // : element.tripStatus === "Booking-Un-Assigned" ? "#4cc0c0"
            // : element.tripStatus === "Booking-Pending" ? "#ff6383"
            // : element.tripStatus === "Booking-Cancelled" ? "#fcc385"
            // : element.tripStatus === "Booking-Cancelled-Note" ? "#4cf0c0"

            const marker = new mapboxgl.Marker({
              color:
                element.tripStatus && element.connectionLost
                  ? "#676666"
                  : element.tripStatus === "Trip-Started"
                  ? "#c3c3c3"
                  : element.tripStatus === "Trip-Arrived-At-Pickup-Location"
                  ? "#dbc7a3"
                  : element.tripStatus === "Trip-Passenger-Picked-Up"
                  ? "#28a745"
                  : element.tripStatus === "Trip-Arrived-To-Dropped-Off"
                  ? "var(--color-130)"
                  : element.tripStatus === "Trip-Passenger-Dropped-Off"
                  ? "#f89780"
                  : element.tripStatus === "Trip-Completed"
                  ? "#bb6955"
                  : element.tripStatus === "Trip-Completed-Note"
                  ? "#fa9a27"
                  : "var(--color-81)",
            })
              .setLngLat(element.location)
              .setPopup(
                new mapboxgl.Popup({ offset: 25 }).setHTML(
                  `<div class='p-1'>
                    ${
                      trip_exceed_distance
                        ? `<div style='color:red'>${this.$t(
                            "exceeding-the-maximum-allowed-distance"
                          )}</div>`
                        : ""
                    }

                    ${
                      element.trip_id
                        ? `<div>${this.$t("trip-id")} : ${element.tripId}</div>`
                        : ""
                    }
                    ${
                      element.employeeID
                        ? `<div>${this.$t("employee-id")} : ${
                            element.employeeID
                          }</div>`
                        : ""
                    }
                    ${
                      element.operationalID
                        ? `<div>${this.$t("operational-id")} : ${
                            element.operationalID
                          }</div>`
                        : ""
                    }
                    ${
                      element.vehicleType
                        ? `<div>${this.$t("vehicle-type")} : ${
                            element.vehicleType
                          }</div>`
                        : ""
                    }
                    ${
                      element.phone_number || element.tripId
                        ? `<div class='d-flex justify-content-center mt-3'>
                          ${
                            element.phone_number
                              ? `<button id='sendMsgBtn' class="me-1 btn btn-secondary btn-sm">
                              ${this.$t("send-message")}
                            </button>`
                              : ""
                          }
                          ${
                            element.tripId
                              ? `<button id="tripDetailBtn" class="ms-1 btn btn-primary btn-sm">
                                  ${this.$t("trip-details")}
                                </button>
                                `
                              : ""
                          } 
                          </div>`
                        : ""
                    }
                  </div>`
                )
              )
              .addTo(map);

            // Extend the bounds to include all marker's location
            bounds.extend(element.location);

            marker.getElement().addEventListener("click", () => {
              setTimeout(() => {
                if (document.getElementById("sendMsgBtn")) {
                  document
                    .getElementById("sendMsgBtn")
                    .addEventListener("click", () => this.sendMessage(element));
                }
                if (document.getElementById("tripDetailBtn")) {
                  document
                    .getElementById("tripDetailBtn")
                    .addEventListener("click", () =>
                      this.$router.push(`/manage-trips?id=${element.tripId}`).catch(() => {})
                    );
                }
              }, 100);
            });

            if (trip_exceed_distance) {
              marker.getElement().click();
              this.$router.replace({ query: {} }).catch(() => {});
            }

            markers[element.id] = marker;
            temp[element.id] = element;
          }
        }
        // Filter out null values from temp if there are any left
        temp = temp.filter(el => el !== null);
        // calculate the total number of vehicles, drivers and deadhead trips: 
        this.totalVehicles = temp.filter((each) => each.operationalID).length;
        this.totalDrivers = temp.filter((each) => each.employeeID).length;
        this.totalDeadheadTrips = temp.filter((each) => each.isDeadhead === true || !each.reservation).length;
      }
      // Fit the map to the bounds
      if (!bounds.isEmpty() && map?.fitBounds && (this.selected_client || this.selected_sales_orders || this.selected_vehicle)) {
        const southwest = bounds.getSouthWest();
        const northeast = bounds.getNorthEast();
        
        const latDiff = Math.abs(southwest.lat - northeast.lat);
        const lngDiff = Math.abs(southwest.lng - northeast.lng);

        const diagonalDistance = Math.sqrt(latDiff ** 2 + lngDiff ** 2);
        
        let dynamicMaxZoom;
        if (diagonalDistance > 20) {
          dynamicMaxZoom = 4; 
        } else if (diagonalDistance > 10) {
          dynamicMaxZoom = 5; 
        } else if (diagonalDistance > 5) {
          dynamicMaxZoom = 10;
        } else {
          dynamicMaxZoom = 12;
        }

        map.fitBounds(bounds, {
          padding: 50,
          maxZoom: dynamicMaxZoom,
        });
      }
    },
    setMapBox() {
      if (document.getElementById(`gps-track-map-box`)) {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_PK;

        // Check if the RTL plugin has already been loaded
        if (mapboxgl.getRTLTextPluginStatus() === "unavailable") {
            mapboxgl.setRTLTextPlugin(
              "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
            null,
            true // Lazy load the plugin
          );
        }

        map = new mapboxgl.Map({
          container: `gps-track-map-box`,
          style: "mapbox://styles/mapbox/streets-v12",
          center: [46.715022884817245, 24.642516582053403],
          zoom: 8,
          language: this.isLangRtl ? "ar" : "en",
        });

        map.on("style.load", () => {
          this.setMarkers();
          this.loadAllZone();
          if (this.devices?.length) this.checkTripExceedDistance();
        });
        this.resetMapLocation();
      }
    },
    sendMessage(element) {
      this.message_data = element;
      this.$bvModal.show("send-message-modal");
    },
    async getData() {
      this.loading = true;
      this.error = null;

      try {
        let { dashboardData } = await VehicleService.get("dashboard");
        if (dashboardData?.length) {
          this.devices = dashboardData.filter(
            (each) =>
              (each?.streamaxLastKnownLocation ||
                each?.machinesTalkLastKnownLocation) &&
              each?.tripStatus &&
              each?.tripStatus?.startsWith("Trip-")
          );

          this.devices = await Promise.all(
            this.devices?.map(async (rec) => {
              const location =
                rec?.streamaxLastKnownLocation ||
                rec?.machinesTalkLastKnownLocation;
              const address = await this.getMarkerInfo(location);

              return {
                id: rec?._id,
                phone_number: rec?.phoneNumber,
                name: rec?.driverName,
                driver_name: rec?.driverName,
                vehicle_name:
                  rec?.vehicleMake && rec?.vehicleModel
                    ? `${rec?.vehicleMake} ${rec?.vehicleModel}`
                    : null,
                vehicleId: rec?.vehicleId,
                plate_number: rec?.plateNumber,
                location,
                address,
                speed: rec?.speed,
                trip_id: rec?.tripId ? "journey #" + rec.tripId : null,
                tripId: rec?.tripId,
                client_id: rec?.clientId,
                client_name: rec?.clientName,
                tripStatus: rec?.tripStatus,
                gpsLastLocationDate: rec?.gpsLastLocationDate,
                connectionLost: rec?.gpsLastLocationDate
                  ? this.connectionLost(rec.gpsLastLocationDate)
                  : true,
                locationInZone: this.locationInZone(rec?.vehicleId, location),
                operationalID: rec?.operationalID,
                vehicleType: rec?.vehicleType,
                employeeID: rec?.employeeID,
                reservation: rec?.reservation,
                isDeadhead: rec?.isDeadhead,
              };
            })
          );
          this.setClientOptions();
          this.setSalesOrdersOptions();
          this.setOptions();
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.error = error.message;
        this.loading = false;
      }
    },
    setSalesOrdersOptions() {
      let temp = [];
      for (let i = 0; i < this.devices.length; i++) {
        const element = this.devices[i];
        if (!temp?.find((each) => each.value === element?.reservation))
          temp.push({
            value: element?.reservation,
            text: element?.reservation,
          });
      }
      if (temp.length) this.sales_orders_options = temp;
    },
    setClientOptions() {
      let temp = [];
      for (let i = 0; i < this.devices.length; i++) {
        const element = this.devices[i];
        if (!temp?.find((each) => each.value === element?.client_id))
          temp.push({
            value: element?.client_id,
            text: element?.client_name,
          });
      }
      if (temp.length) this.client_options = temp;
    },
    setOptions() {
      let options = [];

      const ids = this.devices?.map(({ id }) => id);
      const filtered = this.devices.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );

      options = filtered
        .filter((each) =>
          // this.selected_filter === "online"
          // ? each.tripStatus && !each.connectionLost
          // : this.selected_filter === "plate-number"
          // ? each.plate_number :
          this.selected_filter === "driver-id"
            ? each.employeeID
            // : this.selected_filter === "trip-id"
            // ? each.trip_id
            : each
        )
        ?.map((each) => {
          return {
            value: each.id,
            text:
              this.selected_filter === "all"
                // || this.selected_filter === "online"
                ? each.operationalID
                // : this.selected_filter === "plate-number"
                // ? each.plate_number
                : this.selected_filter === "driver-id"
                  ? each.employeeID
                  // : this.selected_filter === "trip-id"
                  // ? each.trip_id
                  : each.name,
          };
        });
      if (this.selected_filter === "all") {
        options = options.filter((option) => option.text);
      }
      if (options.length)
        options.unshift({
          value: null,
          text: "select-option",
        });
      else
        options.unshift({
          value: null,
          text: "no-option-available",
        });

      this.options = options;
    },
    checkLostDeviceConnection() {
      this.devices = this.devices?.map((each) => {
        each["connectionLost"] = each.gpsLastLocationDate
          ? this.connectionLost(each.gpsLastLocationDate)
          : true;
        return each;
      });
      this.setMarkers();
    },
    connectionLost(date) {
      const a = moment();
      const b = moment(date);
      const minutes = a.diff(b, "minutes");
      return minutes > 5;
    },
    getZones(clientId) {
      this.loading = true;
      this.error = null;
      this.zones = [];

      LongTermsAgreementService.search({
        select: "_id,zone.name,zone.arabicName,zone.location,vehicles",
        client: clientId,
        status: "active",
      })
        .then(({ items }) => {
          let zones = [];
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (!zones?.find((each) => each._id === item?.zone?._id))
              zones.push({
                ...item?.zone,
                ...{ vehicles: item?.vehicles },
              });
          }
          this.zones = zones;
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadAllZone() {
      if (this.zones.length)
        for (let i = 0; i < this.zones.length; i++) {
          const zone = this.zones[i];
          if (
            zone?._id &&
            zone?.location &&
            zone?.location?.coordinates &&
            zone.location.coordinates.length
          ) {
            let coordinates = [];
            for (let i = 0; i < zone.location.coordinates.length; i++) {
              const element = zone.location.coordinates[i];
              for (let j = 0; j < element.length; j++) {
                const point = element[j];
                coordinates.push([point[0], point[1]]);
              }
            }

            if (map.getSource(`zone-${zone._id}`)) {
              // Remove a data source.
              map.removeLayer(`outline-${zone._id}`);
              map.removeLayer(`zone-${zone._id}`);
              map.removeSource(`zone-${zone._id}`);
            }

            // Add a data source containing GeoJSON data.
            map.addSource(`zone-${zone._id}`, {
              type: "geojson",
              data: {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  // These coordinates outline Maine.
                  coordinates: [coordinates],
                },
              },
            });

            // Add a new layer to visualize the polygon.
            map?.addLayer({
              id: `zone-${zone._id}`,
              type: "fill",
              source: `zone-${zone._id}`, // reference the data source
              layout: {},
              paint: {
                "fill-color": "#7e909a",
                "fill-opacity": 0.2,
              },
            });

            // Add a black outline around the polygon.
            map?.addLayer({
              id: `outline-${zone._id}`,
              type: "line",
              source: `zone-${zone._id}`,
              layout: {},
              paint: {
                "line-color": "#7e909a",
                "line-width": 1,
              },
            });
          }
        }
    },
    loadZone(zone) {
      if (
        zone?._id &&
        zone?.location &&
        zone?.location?.coordinates &&
        zone.location.coordinates.length
      ) {
        let coordinates = [];
        for (let i = 0; i < zone.location.coordinates.length; i++) {
          const element = zone.location.coordinates[i];
          for (let j = 0; j < element.length; j++) {
            const point = element[j];
            coordinates.push([point[0], point[1]]);
          }
        }

        if (map.getSource(`zone`)) {
          // Remove a data source.
          map.removeLayer(`outline`);
          map.removeLayer(`zone`);
          map.removeSource(`zone`);
        }

        // Add a data source containing GeoJSON data.
        map.addSource(`zone`, {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: {
              type: "Polygon",
              // These coordinates outline Maine.
              coordinates: [coordinates],
            },
          },
        });

        // Add a new layer to visualize the polygon.
        map?.addLayer({
          id: `zone`,
          type: "fill",
          source: `zone`, // reference the data source
          layout: {},
          paint: {
            "fill-color": "#0080ff",
            "fill-opacity": 0.2,
          },
        });

        // Add a black outline around the polygon.
        map?.addLayer({
          id: `outline`,
          type: "line",
          source: `zone`,
          layout: {},
          paint: {
            "line-color": "#0080ff",
            "line-width": 1,
          },
        });
      }
    },
    unloadZone() {
      if (map.getSource(`zone`)) {
        // Remove a data source.
        map.removeLayer(`outline`);
        map.removeLayer(`zone`);
        map.removeSource(`zone`);
      }
    },
    checkTripExceedDistance() {
      const { driver, vehicle, trip } = this.$route.query;
      if (driver && vehicle && trip) {
        const rec = this.devices?.find(
          (each) =>
            each.id == driver &&
            each.vehicleId == vehicle &&
            each.tripId == trip
        );
        if (rec) this.selectVehicle(rec);
      }
    },
    setOptionsForLevelFilter() {
      let options = [];
      const ids = this.devices?.map(({ id }) => id);
      const filtered = this.devices.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      if (this.selected_filter === 'client-id') {
        options = filtered
          .filter((each) =>
            each.client_id === this.selected_client
          )
          ?.map((each) => {
            return {
              value: each.id,
              text:
                this.selected_filter === "client-id" && this.selected_type === 1
                  ? each.operationalID
                  : this.selected_filter === "client-id" && this.selected_type === 2
                    ? each.employeeID
                    : each.name,
            };
          });
      } else {
        options = this.devices
          .filter((each) =>
            each.reservation === this.selected_sales_orders
          )
          ?.map((each) => {
            return {
              value: each.id,
              text:
                this.selected_filter === "sales-order" && this.selected_type === 1
                  ? each.operationalID
                  : this.selected_filter === "sales-order" && this.selected_type === 2
                    ? each.employeeID
                    : each.name,
            };
          });
      }
      if (options.length)
        options.unshift({
          value: null,
          text: "select-option",
        });
      else
        options.unshift({
          value: null,
          text: "no-option-available",
        });

      this.options_selected_device_level = options;
    },
    resetClient() {
      this.selected_type = null;
      this.selected_device_level = null;
      this.selectVehicle(null);
    },
    resetMapLocation() {
      const bounds = new mapboxgl.LngLatBounds();
      if (this.devices.length) {
        for (let i = 0; i < this.devices.length; i++) {
          const element = this.devices[i]; 
          if (element.location) {
            bounds.extend(element.location);
          }
        }
      }

      // Fit the map to the bounds
      if (!bounds.isEmpty() && map?.fitBounds) {
        
        const southwest = bounds.getSouthWest();
        const northeast = bounds.getNorthEast();
        
        const latDiff = Math.abs(southwest.lat - northeast.lat);
        const lngDiff = Math.abs(southwest.lng - northeast.lng);

        const diagonalDistance = Math.sqrt(latDiff ** 2 + lngDiff ** 2);
        
        let dynamicMaxZoom;
        if (diagonalDistance > 20) {
          dynamicMaxZoom = 4; 
        } else if (diagonalDistance > 10) {
          dynamicMaxZoom = 5; 
        } else if (diagonalDistance > 5) {
          dynamicMaxZoom = 10;
        } else {
          dynamicMaxZoom = 12;
        }

        map.fitBounds(bounds, {
          padding: 50,
          maxZoom: dynamicMaxZoom,
        });
      }
    },
  },
  watch: {
    clientInfo: {
      immediate: true,
      handler(info) {
        if (info?._id) {
          this.getZones(info?._id);
        }
      },
    },
    userInfo: {
      immediate: true,
      handler(info) {
        if (info?.groups.includes("clients")) this.filter_options.pop();
      },
    },
    selected_filter(val, old) {
      if (!val && old){
        this.selected_sales_orders = null;
        this.selected_client = null;
        this.selectVehicle(null);
        this.resetMapLocation();
      }
      if (val) {
        this.setOptions();
        this.selected_device = null;
        this.selected_client = null;
        this.selected_sales_orders= null;
        this.selectVehicle(null);
      }
    },
    selected_zone(zone) {
      if (zone) {
        this.loadZone(zone);
        const coordinates = zone?.location?.coordinates[0];
        if (coordinates) {
          map.flyTo({
            center: coordinates[coordinates.length - 1],
            essential: true,
          });
        }
      } else {
        this.unloadZone();
      }
    },
    selected_device(val, old) {
      if (!val && old) {
        this.selected_device = null;
        this.selectVehicle(null);
        this.resetMapLocation();
      }
      if (val) {
        const rec = this.devices?.find((each) => each.id === val);
        if (rec) this.selectVehicle(rec);
      }
    },
    selected_client(val, old) {
      if (!val && old){
        this.resetClient();
        this.resetMapLocation();
      } 
      if (val) {
        this.selected_device = null;
        let options = [];
        options = this.devices
          .filter((each) => each.client_id === val)
          ?.map((each) => {
            return {
              value: each.id,
              text: each.name,
            };
          });
        if (options.length)
          options.unshift({
            value: null,
            text: "select-option",
          });
        else
          options.unshift({
            value: null,
            text: "no-option-available",
          });

        this.options = options;
        this.setMarkers();
      }
    },
    selected_sales_orders(val, old) {
      if (!val && old){
        this.resetClient();
        this.resetMapLocation();
      } 
      if (val) {
        this.selected_device = null;
        let options = [];
        options = this.devices
          .filter((each) => each.reservation === val)
          ?.map((each) => {
            return {
              value: each.id,
              text: each.name,
            };
          });
        if (options.length)
          options.unshift({
            value: null,
            text: "select-option",
          });
        else
          options.unshift({
            value: null,
            text: "no-option-available",
          });

        this.options = options;
        this.setMarkers();
      }
    },
    async location_update_third_party(val) {
      if (val?.driver?._id) {
        const deviceFound =
        this.devices && this.devices.length
        ? this.devices?.find((each) => each.id === val.driver._id)
        : null;
        const relatedDevice =
          !this.clientInfo?._id ||
          (this.clientInfo?._id &&
            val?.client?._id &&
            this.clientInfo?._id === val.client._id);
        if (deviceFound) {
          this.devices = await Promise.all(
            this.devices?.map(async (each) => {
              if (each.id === val.driver._id) {
                each.location = [val.lon, val.lat];
                each.address = await this.getMarkerInfo(each.location);
                each["speed"] = val?.speed;
                each["locationInZone"] = this.locationInZone(
                  each?.vehicleId,
                  each.location
                );
                each["gpsLastLocationDate"] = new Date().toISOString();
                each["connectionLost"] = this.connectionLost(
                  new Date().toISOString()
                );
                each["tripStatus"] = val?.trip?.status;
              }
              return each;
            })
          );
        } else if (relatedDevice && val.lon && val.lat && val?.driver?._id) {
          const location = [val.lon, val.lat];
          const address = await this.getMarkerInfo(location);

          this.devices.push({
            id: val?.driver?._id,
            phone_number: val?.driver?.mobileNumber,
            name: val?.driver?.name,
            driver_name: val?.driver?.name,
            vehicle_name:
              val?.vehicle?.make?.name && val?.vehicle?.model?.name
                ? `${val?.vehicle?.make?.name} ${val?.vehicle?.model?.name}`
                : null,
            vehicleId: val?.vehicle?._id,
            plate_number: val?.vehicle?.plateNumber,
            location,
            address,
            speed: val?.speed,
            trip_id: val?.trip?._id ? "journey #" + val.trip._id : null,
            tripId: val?.trip?._id,
            client_id: val?.client?._id,
            client_name: val.client?.name,
            tripStatus: val?.trip?.status,
            gpsLastLocationDate: new Date(),
            connectionLost: this.connectionLost(new Date()),
            locationInZone: this.locationInZone(val?.vehicle?._id, location),
            operationalID: val?.vehicle?.operationalID,
            vehicleType: val?.vehicle?.vehicleType?.name,
            employeeID: val?.driver?.employeeID,
          });
        }
        this.setClientOptions();
        this.setSalesOrdersOptions();
        this.setOptions();
        this.setMarkers();
      }
    },
    update_trip_status(val) {
      if (val?.trip?._id) {
        const deviceFound =
          this.devices && this.devices.length
            ? this.devices?.find((each) => each.tripId === val.trip._id)
            : null;
        if (deviceFound) {
          this.devices = this.devices?.map((each) => {
            if (each.tripId === val.trip._id) {
              each["tripStatus"] = val?.trip?.status;
            }
            return each;
          });
          this.setClientOptions();
          this.setSalesOrdersOptions();
          this.setOptions();
          this.setMarkers();
        }
      }
    },
    loading(val) {
      if (!val) {
        setTimeout(() => {
          this.setMapBox();
        }, 100);
      }
    },
    $route() {
      if (this.devices?.length) this.checkTripExceedDistance();
    },
    selected_type() {
      this.setOptionsForLevelFilter()
    },
    selected_device_level(val, old) {
      if (!val && old) this.selectVehicle(null);
      if (val) {
        const rec = this.devices?.find((each) => each.id === val);
        if (rec) this.selectVehicle(rec);
      }
    },
  },
  computed: {
    location_update_third_party() {
      return state.location_update_third_party;
    },
    update_trip_status() {
      return state.update_trip_status;
    },
    userInfo() {
      return this.$store.getters["enums/user_info"];
    },
    clientInfo() {
      return this.$store.getters["enums/client_info"];
    },
    filter_options() {
      return [
        {
          value: "all",
          text: "vehicles",
        },
        // {
        //   value: "online",
        //   text: "online-vehicles",
        // },
        // {
        //   value: "plate-number",
        //   text: "by-vehicle-plate-number",
        // },
        {
          value: "driver-id",
          text: "drivers",
        },
        // {
        //   value: "trip-id",
        //   text: "by-journey-id",
        // },
        {
          value: "client-id",
          text: "clients",
        },
        {
          value: "sales-order",
          text: "sales-orders",
        },
      ];
    },
    event_types() {
      return [
        // {
        //   text: this.$t("device-out-zone"),
        //   value: "locationInZone",
        //   background: "var(--color-77)",
        //   border: "1px solid var(--color-77)",
        // },
        // {
        //   text: this.$t("selected-device"),
        //   value: "selectedDevice",
        //   background: "var(--color-78)",
        //   border: "1px solid var(--color-78)",
        // },
        {
          text: this.$t("lost-device-connection-msg"),
          value: "connectionLost",
          background: "#676666",
          border: "1px solid #676666",
        },
        // {
        //   text: this.$t("Booking-Confirmed"),
        //   value: "Booking-Confirmed",
        //   background: "#ffcd56",
        //   border: "1px solid #ffcd56",
        // },
        // {
        //   text: this.$t("Booking-Re-Assigned"),
        //   value: "Booking-Re-Assigned",
        //   background: "#37a2eb",
        //   border: "1px solid #37a2eb",
        // },
        // {
        //   text: this.$t("Booking-Un-Assigned"),
        //   value: "Booking-Un-Assigned",
        //   background: "#4cc0c0",
        //   border: "1px solid #4cc0c0",
        // },
        // {
        //   text: this.$t("Booking-Pending"),
        //   value: "Booking-Pending",
        //   background: "#ff6383",
        //   border: "1px solid #ff6383",
        // },
        // {
        //   text: this.$t("Booking-Cancelled"),
        //   value: "Booking-Cancelled",
        //   background: "#fcc385",
        //   border: "1px solid #fcc385",
        // },
        // {
        //   text: this.$t("Booking-Cancelled-Note"),
        //   value: "Booking-Cancelled-Note",
        //   background: "#4cf0c0",
        //   border: "1px solid #4cf0c0",
        // },
        {
          text: this.$t("Trip-Started"),
          value: "Trip-Started",
          background: "#c3c3c3",
          border: "1px solid #c3c3c3",
        },
        {
          text: this.$t("Trip-Arrived-At-Pickup-Location"),
          value: "Trip-Arrived-At-Pickup-Location",
          background: "#dbc7a3",
          border: "1px solid #dbc7a3",
        },
        {
          text: this.$t("Trip-Passenger-Picked-Up"),
          value: "Trip-Passenger-Picked-Up",
          background: "#28a745",
          border: "1px solid #28a745",
        },
        {
          text: this.$t("Trip-Arrived-To-Dropped-Off"),
          value: "Trip-Arrived-To-Dropped-Off",
          background: "var(--color-130)",
          border: "1px solid var(--color-130)",
        },
        {
          text: this.$t("Trip-Passenger-Dropped-Off"),
          value: "Trip-Passenger-Dropped-Off",
          background: "#f89780",
          border: "1px solid #f89780",
        },
        // {
        //   text: this.$t("Trip-Completed"),
        //   value: "Trip-Completed",
        //   background: "#bb6955",
        //   border: "1px solid #bb6955",
        // },
        // {
        //   text: this.$t("Trip-Completed-Note"),
        //   value: "Trip-Completed-Note",
        //   background: "#fa9a27",
        //   border: "1px solid #fa9a27",
        // },
        // {
        //   text: this.$t("no-trip"),
        //   value: "default",
        //   background: "var(--color-81)",
        //   border: "1px solid var(--color-81)",
        // },
      ];
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch("enums/GET_DRIVER_AVAILABILITY");
    this.$store.dispatch("enums/GET_VEHICLE_AVAILABILITY");
    setInterval(() => {
      this.checkLostDeviceConnection();
    }, 60000);
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/dashboard.json"),
      ar: require("@/services/i18n/locales/ar/dashboard.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 75vh;
  display: flex;
  flex-direction: column;

  .list-container {
    box-shadow: 0 2px 3px 0 var(--color-38);
    background-color: var(--color-01);
    width: 300px;

    .vehicle-list {
      max-height: 52vh;
      overflow: auto;

      .vehicle-block {
        &:hover {
          background-color: var(--color-31);
        }

        font-size: 18px;
        color: var(--color-17);

        .timeline {
          font-size: 12px;
          color: var(--color-32);
        }
      }
      .selected-vehicle {
        background-color: var(--color-23) !important;
        color: var(--color-01) !important;
        font-weight: 500 !important;
        .timeline {
          color: var(--color-01) !important;
        }
      }
    }
  }

  .vehicle-list::-webkit-scrollbar {
    width: 5px;
  }

  .vehicle-list::-webkit-scrollbar-track {
    background: var(--color-44);
  }

  .vehicle-list::-webkit-scrollbar-thumb {
    background: var(--color-23);
  }

  .vehicle-list::-webkit-scrollbar-thumb:hover {
    background: var(--color-45);
  }
}

.counter {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  background: var(--color-11);
  border-radius: 4px;
  padding: 5px;
  &__count {
    color: var(--color-03);
    .active {
      color: var(--color-113);
    }
  }
  &__status {
    color: var(--color-02);
  }
}

.mab-container {
  position: relative;

  .box-info-map {
    background-color: var(--color-21);
    width: 250px;
    padding: 8px;
    // height: 100px;
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    border-bottom-left-radius: 12px;

    .box-info-map-item {
      display: flex;
      align-items: center;
      gap: 4px;
      border-bottom: 1px solid #eee;
      padding: 6px 0;
      h5{
        color: var(--color-03);
        font-size: 13px;
        margin: 0;
      }
      p{
        // color: var(--color-03);
        color: var(--color-113);
        font-size: 13px;
        margin: 0;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
